import { BrowserRouter } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AnimatedRoutes from "./components/AnimatedRoutes";
import CookieConsent from "./components/CookieConsent";
import { ContactDialogProvider } from "./components/ContactDialog";
import { useTabTitleNudge } from "@/hooks/use-tab-title-nudge";
import { professionalServiceSchema } from "@/lib/schema";

const App = () => {
  useTabTitleNudge();

  return (
    <HelmetProvider>
      {/* Site-wide ProfessionalService schema — present on every route,
          independent of each page's own Seo/JSON-LD (e.g. breadcrumbs). */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(professionalServiceSchema())}
        </script>
      </Helmet>
      {/* No global QueryClient/Tooltip/Toast providers: no public page uses
          them, and they added unused JS to every page load. The sign-in page
          renders its own <Toaster />. */}
      <BrowserRouter>
        <ContactDialogProvider>
          <AnimatedRoutes />
          <CookieConsent />
        </ContactDialogProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
